module.exports = __webpack_public_path__ + "static/media/martin_bernstein_6.69caee0a.png";